<template>
	<el-dialog :visible.sync="showreceiver" title="固定接收人" width="600px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false">
		<div class="receiver">
			<el-row style="margin-bottom:5px;">
				<el-col :span="1" style="color:transparent">1</el-col>
				<el-col :span="10" style="text-align: center;">
					<span>请接收人扫码绑定</span>
				</el-col>
				<el-col :span="2" style="color:transparent">1</el-col>
				<el-col :span="10" style="text-align: center;"><span>已添加人员</span> <el-link icon="el-icon-refresh" style="margin-left:10px;font-size:9pt;" type="primary" v-if="handlerefresh" @click="GetWxReceiver" :underline="false">刷新查看</el-link></el-col>
			</el-row>
			<el-row>
				<el-col :span="1" style="color:transparent">1</el-col>
				<el-col :span="10">
					<div style="text-align:center;">
						<el-image :src="ewmsrc">
							 <div slot="error" class="image-slot">
							      {{loadtext}}
							 </div>
						  <div slot="placeholder" class="image-slot">
							加载中<span class="dot">...</span>
						  </div>
						</el-image>
					</div>
				</el-col>
				<el-col :span="1" >
					 <div class="line"></div>
				</el-col>
				<el-col :span="12">
					<el-row>
						<el-col :span="3" class="headimg" :key="index" v-for="(nick,index) in nicklist" >
							<div class="headdiv">
								<i @click="removewxuser(nick.wxopenid)" class="el-icon-close" style="color:#CCCCCC;cursor:pointer;"></i>
							</div>
							<el-avatar shape="square" :size="70" fit="fill" :src="nick.headimgurl" style="z-index:998;"></el-avatar>
							<div style="text-align:center;">
								<span>{{nick.nickname}}</span>
							</div>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
		</div>
	</el-dialog>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {
	},
	props: {
		
	},
	data() {
		return {
			id:'',
			divclass:'receiver',
			showreceiver:false,
			ewmsrc:'',
			nicklist:[],
			loadtext:'加载中',
			times:0,
			handlerefresh:false
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/msg/setreceiver_wx.scss');
		});
	},
	methods:{
		init(param){
			this.times=0;
			this.showreceiver=true;
			this.id=param.id;
			this.GetWxReceiver();
			this.loadewm();
		},
		GetWxReceiver(){
			var that=this;
			this.$apipost.get.GetWxReceiver({id:this.id}).then(res => {
				if (res != '') {
					if(res.list!=undefined)
						that.nicklist=res.list;
				}
			});
		},
		loadewm(){
			var that=this;
			var paraminfo={
				type:'添加微信模板固定接收人',
				value:{
					id:this.id
				}
			};
			this.$apipost.get.CreateTempEwm({paraminfo:paraminfo}).then(res => {
				if (res != '') {
					if(res.state=='1'){
						that.ewmsrc=res.img;
						that.RefreshReceiver();
					}else{
						that.loadtext=res.message;
					}
				}
			});
		},
		//移除已添加的接收人
		removewxuser(wxopenid){
			var that=this;
			var paraminfo={
				id:this.id,
				wxopenid:wxopenid
			}
			this.$apipost.post.SaveWxReceiver({paraminfo:paraminfo,isadd:0}).then(res => {
				if (res != '') {
					if(res.state=='1'){
						var list=that.nicklist.filter(function(e){
							return e.wxopenid!=wxopenid
						});
						that.nicklist=list;
					}else{
						this.$tool.message('移除失败', 0);
					}
				}
			});
		},
		RefreshReceiver(){
			var that=this;
			if(this.times<5){
				if(this.times>0)
					that.GetWxReceiver();
				setTimeout(function(){
					that.RefreshReceiver();
				},10000);
				this.times++;
			}else{
				setTimeout(function(){
				  return 33;
				},1000);
				 clearTimeout(33);
				 this.handlerefresh=true;
			}
		}
	}
}
</script>

<style>
</style>
